export default {
  eyebrow: 'Portail partenaire',
  title: 'Compte',
  description: 'Les détails de votre compte partenaire.',
  page: {
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur.',
    editing_notice: 'Modification — les changements sont visibles par votre équipe et vos clients.',
  },
  profile: {
    form: {
      name: {
        label: 'Nom du partenaire',
        hint: "Le nom légal / de l'entité. Utilisé sur les documents de facturation.",
      },
      display_name: {
        label: 'Nom affiché aux consommateurs',
        hint: 'Le libellé « Propulsé par ___ » que vos clients voient dans vos restaurants. Par défaut, le nom du partenaire si laissé vide.',
      },
      support_email: {
        label: 'E-mail de contact',
        hint: 'Comment FoodAmigos et vos clients peuvent vous joindre. Votre e-mail de connexion reste inchangé.',
      },
      invoicing_emails: {
        label: 'E-mails de facture',
        hint: 'Les reçus des factures qui vous sont facturées sont envoyés à chacune de ces adresses. Laissez vide pour utiliser votre e-mail de connexion.',
        placeholder: 'Votre e-mail de connexion',
      },
    },
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  toasts: {
    load_error: 'Impossible de charger les détails de votre compte.',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
